define('views/content/product',['require','views/base/item_page_view','typeahead','bloodhound','views/components/product_reseller_price/product_reseller_prices','collections/product_reseller_prices','views/components/action_history/action_histories','collections/action_histories','models/product_image','views/components/product_image/product_image','collections/product_info_schemas','views/components/product_info/schema_list','text!templates/content/product.html'],function (require) {
  var BaseItemPageView = require("views/base/item_page_view");
  require("typeahead");
  require("bloodhound");

  var ProductPricesView = require("views/components/product_reseller_price/product_reseller_prices");
  var ProductPricesCollection = require("collections/product_reseller_prices");

  var ActionsView = require("views/components/action_history/action_histories");
  var ActionsCollection = require("collections/action_histories");

  var ProductImageModel = require("models/product_image");
  var ProductImageView = require("views/components/product_image/product_image");

  var ProductInfoSchemaCollection = require("collections/product_info_schemas");
  var ProductInfoSchemaView = require("views/components/product_info/schema_list");

  var temp = require("text!templates/content/product.html");
  return BaseItemPageView.extend({
    // html template for the view
    template: _.template(temp),
    className: "product-page page",
    basePath: "products",
    titleKey: "product",

    afterInitialize: function () {
      var _this = this;
      this.actionsCollection = new ActionsCollection([], {
        parameters: {
          product_id: this.model.id,
        },
      });

      var productId = this.model.get("id");

      if (productId && App.user.get("is_staff")) {
        this.productPricesCollection = new ProductPricesCollection(
          this.model.get("pricing_details")
        );
        var product_image_model = this.model.get("product_image");
        product_image_model.product = productId;
        this.productImageModel = new ProductImageModel(product_image_model);

       var productInfoSchemaCollection = new ProductInfoSchemaCollection();
        
       productInfoSchemaCollection.changeFilter('product', productId);
       productInfoSchemaCollection.changeFilter('limit', 100);

       this.productInfoSchemaCollection = productInfoSchemaCollection;
      

      }
    },

    ui: function () {
      return {
        select2Input: '[data-init-plugin="select2"]',
        mainForm: "#main-form",
        submitButton: "#submit-button",

        updatePricesButton: "#update-pricing-button",

        resellerField: "#customer",
        countField: "#count",
        noteField: "#note",
        assignButton: "#assign-button",
        simulateButton: "#simulate-button",
      };
    },

    events: {
      "change form input": "formChanged",
      "change form textarea": "formChanged",
      "change form select": "formChanged",

      "click @ui.submitButton": "submitButtonClicked",
      "click @ui.updatePricesButton": "updatePricesButtonClicked",

      "click @ui.assignButton": "assignButtonClicked",
      "click @ui.simulateButton": "simulateButtonClicked",
    },

    regions: function () {
      return {
        ProductPricesContainer: ".product-prices",
        ActionsContainer: ".action-list",
        ImageContainer: ".product-image",
        InfoSchemaContainer: ".product-info",
      };
    },

    afterRender: function () {
      var _this = this;

      if (this.model.get("id")) {
        this.ActionsContainer.show(
          new ActionsView({
            collection: this.actionsCollection,
          })
        );

        this.ImageContainer.show(
          new ProductImageView({
            model: this.productImageModel,
          })
        );

        this.InfoSchemaContainer.show(
          new ProductInfoSchemaView({
            collection: this.productInfoSchemaCollection,
          })
        );
      }

      this.ProductPricesContainer.show(
        new ProductPricesView({
          collection: this.productPricesCollection,
        })
      );





      // Setup typeahead for reseller field
      var resellersTypeahedEngine = new Bloodhound({
        datumTokenizer: Bloodhound.tokenizers.whitespace,
        queryTokenizer: Bloodhound.tokenizers.whitespace,
        remote: {
          url: App.Config.apiBase + "resellers/typeahead/",
          replace: function (url, query) {
            return (
              url +
              ("?query=" + encodeURIComponent(_this.ui.resellerField.val()))
            );
          },
        },
        identify: function (obj) {
          return obj.id;
        },
      });

      this.ui.resellerField.typeahead(
        {
          minLength: 3,
        },
        {
          name: "resellers",
          source: resellersTypeahedEngine,
          display: "company_name",
        }
      );

      // Get selected customer's id
      this.ui.resellerField.bind("typeahead:select", function (ev, suggestion) {
        _this.selectedReseller = suggestion.id;
      });

    },


    templateHelpers: function () {
      return {
        image_detail: this.productImageModel,
      };
    },

    setupFormValidation: function () {
      this.ui.mainForm.validate({
        rules: {
          license_name: "required",
          category: "required",
          type: "required",
          store_order: "required",
          license_type: "required",
          payment_schedule: "required",
          translations__en__name: "required",
          translations__en__info: "required",
          translations__tr__name: "required",
          translations__tr__info: "required",
          regional_visibility: "required",
        },
        messages: {
          license_name: App.polyglot.t("license_name_required"),
          category: App.polyglot.t("category_required"),
          type: App.polyglot.t("product_type_required"),
          store_order: App.polyglot.t("store_order_required"),
          license_type: App.polyglot.t("license_type_required"),
          payment_schedule: App.polyglot.t("payment_schedule_required"),
          translations__en__name: App.polyglot.t("translations__en__name"),
          translations__en__info: App.polyglot.t("translations__en__info"),
          translations__tr__name: App.polyglot.t("translations__tr__name"),
          translations__tr__info: App.polyglot.t("translations__tr__info"),
          regional_visibility: App.polyglot.t("regional_visibility_required"),
        },

        onfocusout: false,
        onkeyup: false,
        onclick: false,

        showErrors: function (errorMap, errorList) {
          for (var i = 0; i < errorList.length; i++) {
            App.utils.showMessage("error", errorList[i].message);
          }
        },
      });
    },

    updatePricesButtonClicked: function () {
      var _this = this;
      _this.ui.updatePricesButton.addClass("loading disabled");
      Promise.all(
        this.productPricesCollection.models.map(function (priceModel) {
          if (priceModel.updated) {
            if (
              priceModel.get("price") !== null &&
              priceModel.get("price") !== ""
            ) {
              return priceModel.save();
            } else {
              if (priceModel.get("id")) {
                // Delete product price entry
                return $.ajax({
                  url:
                    App.Config.apiBase +
                    "product-prices/" +
                    priceModel.get("id") +
                    "/",
                  method: "delete",
                  success: function (response) {
                    priceModel.set("id", null);
                    priceModel.set("price", null);
                  },
                  error: function (xhr, ajaxOptions, thrownError) {
                    // Show error messages
                    if (xhr.responseJSON.errors) {
                      for (var i = 0; i < xhr.responseJSON.errors.length; i++) {
                        App.utils.showMessage(
                          "error",
                          xhr.responseJSON.errors[i].message
                        );
                      }
                    }
                  },
                });
              }
            }
          }
        })
      ).then(function () {
        _this.ui.updatePricesButton.removeClass("loading disabled");
        App.utils.showMessage(
          "success",
          App.polyglot.t("product_price_update_success")
        );
      });
    },

    assignButtonClicked: function () {
      var _this = this;

      if (this.selectedReseller) {
        _this.ui.assignButton.addClass("loading");

        $.ajax({
          url:
            App.Config.apiBase +
            "products/" +
            this.model.get("id") +
            "/assign_license/",
          method: "post",
          data: {
            reseller: this.selectedReseller,
            count: this.ui.countField.val(),
            note: this.ui.noteField.val(),
          },
          success: function (response) {
            _this.ui.assignButton.removeClass("loading");
            _this.render();

            App.utils.showMessage("success", App.polyglot.t("assign_success"));
          },
          error: function (xhr, ajaxOptions, thrownError) {
            _this.ui.assignButton.removeClass("loading");

            // Show error messages
            if (xhr.responseJSON.errors) {
              for (var i = 0; i < xhr.responseJSON.errors.length; i++) {
                App.utils.showMessage(
                  "error",
                  xhr.responseJSON.errors[i].message
                );
              }
            }
          },
        });
      }
    },

    simulateButtonClicked: function () {
      var _this = this;

      if (this.selectedReseller) {
        _this.ui.simulateButton.addClass("loading");

        $.ajax({
          url: App.Config.apiBase + "purchase-simulation/",
          method: "post",
          contentType: "application/json; charset=utf-8",
          dataType: "json",
          data: JSON.stringify({
            reseller: this.selectedReseller,
            basket: {
              products: [
                {
                  product: _this.model.get("id"),
                  count: _this.ui.countField.val(),
                },
              ],
            },
          }),
          success: function (response) {
            _this.ui.simulateButton.removeClass("loading");
            _this.render();

            App.utils.showMessage(
              "success",
              App.polyglot.t("simulate_purchase_success")
            );
          },
          error: function (xhr, ajaxOptions, thrownError) {
            _this.ui.simulateButton.removeClass("loading");

            // Show error messages
            if (xhr.responseJSON.errors) {
              for (var i = 0; i < xhr.responseJSON.errors.length; i++) {
                App.utils.showMessage(
                  "error",
                  xhr.responseJSON.errors[i].message
                );
              }
            }
          },
        });
      }
    },
  });
});

